class SelectMenu extends HTMLElement {
  constructor() {
    super();
    this.menu = this.querySelector('.menu');
    this.menu.addEventListener('click', (e)=>{
      this.listItem = e.target;
      if(this.menu.classList.contains('open')){
        this.menu.prepend(this.listItem);
      }
      this.listItem.closest('ul').classList.toggle('open'); 
    });

    this.menuList = this.menu.querySelectorAll('li');
    this.menuList.forEach(item => {
      this.itemHref = item.getAttribute('value');
      item.addEventListener('click', () => {
        window.location.pathname = this.itemHref;
      });
      if(window.location.pathname == this.itemHref){
        item.classList.add('current');
      }else if(item.classList.contains('current')){
        item.classList.remove('current');
      }
    });


    // this.menuList = this.menu.querySelectorAll('option');
    // this.menuList.forEach(item => {
    //   this.itemHref = item.getAttribute('value');
    //   if(window.location.pathname == this.itemHref){
    //     item.classList.add('current');
    //     item.setAttribute('selected', 'true');
    //     this.menu.insertBefore(item, this.menu.options[0]);
    //   }else if(item.classList.contains('current')){
    //     item.classList.remove('current');
    //     item.removeAttribute('selected');
    //   }
    // });
    
    // this.menu.options[this.menu.options.selectedIndex].selected = true;
  }
}
customElements.define('select-menu', SelectMenu);

class SelectMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.menu = this.querySelector('#menu_dropdown');
    this.menuList = this.menu.querySelectorAll('li');
    this.btnOpenMenu = this.querySelector('.js-label-menu');
    
    this.menuList.forEach(item => {
      this.itemHref = item.getAttribute('value');
      if(window.location.pathname == this.itemHref){
        item.classList.add('current');
        this.btnOpenMenu.innerHTML = item.innerHTML;
      }
      item.addEventListener('click', () => {
        window.location.pathname = item.getAttribute('value');
      });
    });

    this.btnOpenMenu.addEventListener('click', (e)=>{
      this.menu.classList.toggle('open');
    });
  }
}
customElements.define('select-menu-dropdown', SelectMenuDropdown);

class MenuList extends HTMLElement {
  constructor() {
    super();
    this.menu = this.querySelector('.menu-list');
    this.menuList = this.menu.querySelectorAll('li');
    this.menuList.forEach(item => {
      this.itemLink = item.querySelector('a');
      this.itemHref = this.itemLink.getAttribute('href');
      if(window.location.pathname == this.itemHref){
        this.itemLink.parentNode.classList.add('active');
      }else if(this.itemLink.parentNode.classList.contains('active')){
        this.itemLink.parentNode.classList.remove('active');
      }
    });
  }
}
customElements.define('menu-list', MenuList);
